import { useEffect } from "react"; // Added useEffect
import { BrowserRouter, useNavigate } from "react-router-dom";
import Router from "./Router";
import { ThemeProvider } from "@emotion/react";
import { appTheme } from "./Components/CstmTheme/Theme";
import { CssBaseline } from "@mui/material";
import AlertPopUp from "Components/AlertPopUp";
import OverlayLoader from "Components/OverlayLoader";
import { navigation } from "Utils/Common";

const App = () => {
// useEffect(() => {
//   // --- BYPASS START ---
//   const isIphone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
//   if (isIphone) return; // Exit early if the user is on an iPhone/iPad
//   // --- BYPASS END ---
//     const blockPage = () => {
//       // Wiping the entire body so the source code is no longer in the DOM
//       document.body.innerHTML = `
//         <div style="
//           display: flex; 
//           flex-direction: column;
//           justify-content: center; 
//           align-items: center; 
//           height: 100vh; 
//           background: #000; 
//           color: #ff4d4d; 
//           font-family: sans-serif;
//           text-align: center;
//           padding: 20px;
//         ">
//           <h1 style="font-size: 50px;">🛑 ACCESS BLOCKED</h1>
//           <p style="font-size: 20px; color: #fff;">
//             Developer Tools are strictly prohibited on this platform for security reasons.
//           </p>
//           <button onclick="window.location.reload()" style="
//             margin-top: 20px; padding: 10px 20px; cursor: pointer;
//             background: #ff4d4d; color: white; border: none; border-radius: 5px;
//           ">Try Again</button>
//         </div>
//       `;
//       document.body.style.overflow = "hidden";
//     };

//     const detectDevTools = () => {
//       // Method 1: Check screen size difference (DevTools takes up space)
//       const threshold = 160;
//       const widthDiff = window.outerWidth - window.innerWidth > threshold;
//       const heightDiff = window.outerHeight - window.innerHeight > threshold;

//       if (widthDiff || heightDiff) {
//         blockPage();
//       }

//       // Method 2: The Debugger Loop
//       // This forces the browser to pause if Inspect is open, triggering our detection
//       const start = new Date().getTime();
//       const end = new Date().getTime();
//       if (end - start > 100) {
//         blockPage();
//       }
//     };

//     // Run detection every 500ms to catch users who open it later
//     const interval = setInterval(detectDevTools, 500);

//     // Initial check in case they opened it before the site loaded
//     detectDevTools();

//     // Prevent keyboard shortcuts
//     const handleKeyDown = (e: KeyboardEvent) => {
//       if (
//         e.key === "F12" ||
//         ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) ||
//         ((e.ctrlKey || e.metaKey) && e.key === "u")
//       ) {
//         e.preventDefault();
//         blockPage(); // Block immediately on key press
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     window.addEventListener("contextmenu", (e) => e.preventDefault());

//     return () => {
//       clearInterval(interval);
//       window.removeEventListener("keydown", handleKeyDown);
//     };
//   }, []);


// 1. Keep this helper component outside the main App or at the top
const NavigateSetter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigation.navigate = navigate;
  }, [navigate]);

  return null;
};
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <OverlayLoader />
      <AlertPopUp />
      <BrowserRouter>
        <NavigateSetter />
        <Router />
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
